import { WsOnMessage } from '@wellesley/ws'
import { Notification } from '@wellesley/openapi'

const isUndoNotification = (notification: WsOnMessage<Notification>) =>
  notification.type === 'NOTIFICATION_UNDO'

export default isUndoNotification
